// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"cc457a79","66":"413dc679","100":"a46d5494","175":"4eb14935","232":"bb26bb3d","254":"bbfdb7bc","352":"3c7b6f39","483":"63b3e61d","549":"6cc50507","558":"6fe3f248","565":"21c0cfc1","754":"d7893c09","935":"e7cb03b8"}[chunkId] + ".chunk.js";
};